import React, {useState} from 'react';
import PropTypes from 'prop-types';
import '../../../../../../shared/components/Scoresheet/styles/MatchScoresheetForm.scss';
import {Radio} from 'antd';
import { useTranslation } from 'react-i18next';


const moduleNameClassName = `h-2 heading--white`;
const moduleTitleClassName = `h-2 heading--charcoal`;
const paragraphClassName = 'paragraph--large paragraph--charcoal paragraph--normal'
const errorClassName = 'paragraph--large paragraph--dark-red paragraph--normal'

const ERROR_MESSAGE = 'The answer to the second question under this mission cannot be YES if the first question is answered NO'

const ModuleSection = props => {
  const [moduleError, setModuleError] = useState('');
  const {moduleName, moduleTitle, fields, scoreInput} = props;
  const [form] = Form.useForm();
  const {t} = useTranslation();

  /*
    RULE: 
    The answer to the second question under
    this mission cannot be YES if the first question is answered NO
  */

  const validateRadioOption = (rule, value, callback) => {
    const {field} = rule;
    const module12QuestionTwoResponse = form.getFieldValue('m12_scoring_2');
    const module12QuestionOneResponse = form.getFieldValue('m12_scoring_1');
    if (field === 'm12_scoring_2' && !module12QuestionOneResponse && value) {
      setModuleError(ERROR_MESSAGE);
      callback(ERROR_MESSAGE);
    } else if (field === 'm12_scoring_1' && module12QuestionTwoResponse && !value) {
      setModuleError(ERROR_MESSAGE);
      callback(ERROR_MESSAGE);
    } else {
      setModuleError('');
      callback();
    }
 
  }


  return (
    <div className="scoresheet-module">
      <div className="scoresheet-module__name">
        <h3 className={moduleNameClassName}>{moduleName}</h3>
      </div>

      <div className="m-l-30 m-t-8 scoresheet-module__content">
        <h2 className={moduleTitleClassName}>{moduleTitle}</h2>
        <div className="scoresheet-module__fields-wrapper">
          {fields.map((f) => (

            <div key={f.id} className="scoresheet-module__field">
              <span className={`${paragraphClassName} scoresheet-module__field-label`}>
                {t(f.scoring)}
                :
              </span>
              {f.type !== 'integer' ? (
                <span>
                  {form.getFieldDecorator( f.id, {
                    initialValue: scoreInput[f.id],
                    rules: [{
                      validator: validateRadioOption
                    }]
                  }
                  )(
                    <Radio.Group
                      buttonStyle="solid"
                      className="match-scoresheet-form__radio-wrapper"
                      optionType="button"
                      disabled={scoreInput.is_published}
                    >
                      {f.options.map((o) => (
                        <Radio.Button
                          buttonStyle="solid"
                          className="match-scoresheet-form__radio-btn"
                          key={`${f.id}-${o.value}`}
                          value={o.value}
                          id={o.value}
                        >
                          {t(o.description)}
                        </Radio.Button>
                      ))}
                    </Radio.Group>
                  )}
                </span>
              ) : (
                null
              )}
            </div>
          ))}
        </div>
        <p className={errorClassName}>{moduleError}</p>

      </div>
    </div>
  );
};

ModuleSection.propTypes = {
  moduleName: PropTypes.string,
  moduleTitle: PropTypes.string,
  fields: PropTypes.array,
  form: PropTypes.object.isRequired
};

ModuleSection.defaultProps = {
  moduleName: '',
  moduleTitle: '',
  fields: []
};

export default ModuleSection;